import { ImgHTMLAttributes, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { ENV_MAIN_LOGO } from 'common/constants/env.constants';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';

export const Logo = (props: Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'>): ReactElement => {
  if (ENV_MAIN_LOGO) {
    return (
      <Link to={ROUTES_MAPPING.PROTECTED.DASHBOARD}>
        <img src={ENV_MAIN_LOGO} alt="logo" {...props} />
      </Link>
    );
  }

  return <div />;
};
